import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingService } from 'axis-components/components/loading/loading.service';
import { GmdService } from 'src/app/services/gmd.service';

@Component({
  selector: 'app-gmd-contact',
  templateUrl: './gmd-contact.component.html',
  styleUrls: ['./gmd-contact.component.scss']
})
export class GmdContactComponent implements OnInit, AfterViewInit {
  @Input() selectedCompanyId;
  // @Output() saveContact = new EventEmitter();
  @Output() onAddItem = new EventEmitter<any>();
  companyLocations;
  contactList;
  leftSidebarClosed: Boolean = false;
  navPanel: Boolean = false;
  numericPercent;
  panel: string = '';
  panelShow = this.panel;
  public dropdownTemplate: any;
  touch;
  public showForm = false;
  contactForm: FormGroup;
  public readOnly;
  public selectedRowIndex;
  constructor(private changeDetectorRef: ChangeDetectorRef, private fb:FormBuilder, private gmdService: GmdService,
    private router: Router, public loadingService: LoadingService) { 
      this.loadingService.start();
    }


  onContactAdd() {
    const contact = this.fb.group({
      functionId: '',
      locationId: '',
      locationCompanyName: '',
      phone: '',
      email: '',
      notes: '',
      contactId: ''
    });

    this.contactForm.get('contacts')['controls'].push(contact);
  }

  onContactDelete(row, isFirst?) {
    const contactArray = this.contactForm.get('contacts') as FormArray;
    const idx = row ? row : this.selectedRowIndex;
    if (!isFirst) {
      const req = {
        functionId: contactArray.controls[idx].value.functionId
      }
      if (req.functionId !== '') {
        this.gmdService.deleteContact(req).subscribe((obs: any)=> {
          if (obs.message || obs.Message) {
            this.gmdService.notificationMessage.next("Contact details deleted successfully!");
            this.getContacts(true);
          }
        });
      }
    }
    contactArray.removeAt(idx);
    if (contactArray.length === 0) {
      this.showForm = false;
    } else {
      this.showForm = true;
    }
  }

  addItem(type: string) {
    this.onAddItem.emit(type);
  }
  trackByIndex(index: number): number {
    return index;
  }
  stopProp(event, idx) {
    event.stopPropagation();
    this.selectedRowIndex = idx;
  }
  ngOnInit() {
    this.readOnly = sessionStorage.getItem('isReadOnly');
    if (this.readOnly === 'true') {
      this.loadingService.stop();
    }
    this.getContacts();
    const getCompanyLocationsInput = {
      companyId : sessionStorage.getItem('selectedCompanyId'),
      regionId: sessionStorage.getItem('selectedRegionId') !== '' && sessionStorage.getItem('selectedRegionId') !== null ? Number(sessionStorage.getItem('selectedRegionId')) : -1,
      countryId: sessionStorage.getItem('selectedCountryId') !== '' && sessionStorage.getItem('selectedCountryId') !== null ? sessionStorage.getItem('selectedCountryId') : -1,
      locationId: sessionStorage.getItem('selectedLocationId') !== '' && sessionStorage.getItem('selectedLocationId') !== null ? sessionStorage.getItem('selectedLocationId') : '-1'
    };
    this.gmdService.getCompanyLocation(getCompanyLocationsInput).subscribe((obs)=> this.companyLocations = obs);
  }
  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }
  public patchFormValue() {
    if (this.companyLocations && this.companyLocations.length > 0 && this.contactList && this.contactList.length > 0 && this.contactForm.get('contacts')['controls'] && this.contactForm.get('contacts')['controls'].length > 0) {
      this.contactList.forEach((element, i) => {
        this.companyLocations.forEach((e, j) => {
          if (e.locationId === element.locationId) {
            this.contactForm.get('contacts')['controls'][i].get('locationCompanyName').setValue(this.companyLocations[j].locationName);
            this.changeDetectorRef.detectChanges();
            this.loadingService.stop();
          }
        });
      });
    }
  }
  public getContacts(isEditFlow?: boolean) {
    this.gmdService.getContacts({
      companyId : sessionStorage.getItem('selectedCompanyId'),
      regionId: sessionStorage.getItem('selectedRegionId') !== '' && sessionStorage.getItem('selectedRegionId') !== null ? Number(sessionStorage.getItem('selectedRegionId')) : -1,
      countryId: sessionStorage.getItem('selectedCountryId') !== '' && sessionStorage.getItem('selectedCountryId') !== null ? sessionStorage.getItem('selectedCountryId') : -1,
      locationId: sessionStorage.getItem('selectedLocationId') !== '' && sessionStorage.getItem('selectedLocationId') !== null ? sessionStorage.getItem('selectedLocationId') : '-1'
     }).subscribe((obs) => {
      if (!isEditFlow) {
        this.contactForm = this.fb.group({
          contacts: this.fb.array([this.fb.group({
              functionId: '',
              locationId: '',
              locationCompanyName: ['', Validators.maxLength(50)],
              phone: ['', Validators.maxLength(45)],
              email: ['', Validators.maxLength(50)],
              notes: ''
            })
          ])
        });
        this.onContactDelete(0, true);
      }
      this.contactList = obs;
      // this.loadingService.stop();
      if (this.contactList && this.contactList.length > 0) {
        this.showForm = true;
        this.gmdService.contactCount.next(this.contactList.length);
        this.contactList.forEach((element, i) => {
          if (!isEditFlow) {
            this.onContactAdd();
          }
          this.contactForm.get('contacts')['controls'][i].get('functionId').setValue(element.functionId);
          this.contactForm.get('contacts')['controls'][i].get('locationId').setValue(element.locationId);
          this.contactForm.get('contacts')['controls'][i].get('locationCompanyName').setValue(element.locationName);
          this.contactForm.get('contacts')['controls'][i].get('phone').setValue(element.phone.trim());
          this.contactForm.get('contacts')['controls'][i].get('email').setValue(element.email.trim());
          this.contactForm.get('contacts')['controls'][i].get('notes').setValue(element.notes.trim());
          this.changeDetectorRef.detectChanges();
        });
      } else {
        this.loadingService.stop();
        this.gmdService.contactCount.next(this.contactList.length);
        this.showForm = false;
      }
     });
  }
  /* methods */
  contacts() : FormArray {
    return this.contactForm.get("contacts") as FormArray
  }

  public add(): void {
    this.showForm = true;
  }
  public onCompanySelected(selectedValue, idx) {
    this.contactForm.get('contacts')['controls'][idx].get('locationCompanyName').setValue(selectedValue.locationName);
    this.contactForm.get('contacts')['controls'][idx].get('locationId').setValue(selectedValue.locationId);
    this.changeDetectorRef.detectChanges();
  }
  public saveContact(i: number) {
    this.gmdService.saveContacts({
      "functionId": this.contactForm.get('contacts')['controls'][i].value.functionId ? Number(this.contactForm.get('contacts')['controls'][i].value.functionId) : '',
      "locationId" : this.contactForm.get('contacts')['controls'][i].value.locationId ? Number(this.contactForm.get('contacts')['controls'][i].value.locationId) : '',
      "phone": this.contactForm.get('contacts')['controls'][i].value.phone,
      "email" : this.contactForm.get('contacts')['controls'][i].value.email,
      "notes" : this.contactForm.get('contacts')['controls'][i].value.notes
  }).subscribe((obs)=>{
      this.gmdService.notificationMessage.next("Contact details saved successfully!");
      this.getContacts(true);
    });
  }
}
